module.exports = __webpack_public_path__ + "resource/img/image043.593feac5.png";